<template>
    <a-card type="inner" size="small">
        <a-skeleton :loading="preload" active>
            <a-form :form="form" :layout="formLayout" @submit="handleSubmit">
                <a-divider dashed orientation="left">Form Kelas Klasikal</a-divider>
                <a-form-item label="Nama Kelas Klasikal">
                    <a-input
                        placeholder="Nama Kelas Klasikal"
                        v-decorator="[
                            'name',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Field ini wajib diisi'
                                    }
                                ]
                            }
                        ]"
                    >
                    </a-input>
                </a-form-item>

                <a-form-item>
                    <a-input
                        type="hidden"
                        v-decorator="['training', { initialValue: training }]"></a-input>
                </a-form-item>

                <a-form-item>
                    <a-row type="flex" justify="center" align="top">
                        <a-col>
                            <a-space>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Submit</a-button>
                                <a-button
                                    @click="handleClose"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Tutup</a-button>
                            </a-space>
                        </a-col>
                    </a-row>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-card>
</template>

<script>
export default {
    props: {
        training: {
            type: String,
            required: true
        },
        hash: {
            type: String,
            default: ''
        }
    },
    created() {
        if (this.editing) {
            this.preload = true;
            this.getItem();
        }
    },
    computed: {
        editing() {
            return this.hash !== "";
        }
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            item: {},
        };
    },
    methods: {
        getItem() {
            this.$http
                .get(
                    this.routeUri("api.training-classes.show", {
                        class: this.hash
                    })
                )
                .then(res => (this.item = res.data))
                .finally(() => (this.preload = false));
        },
        handleSubmit(e) {
            e.preventDefault(e);

            this.form.validateFields((err, formData) => {
                if (!err) {
                    this.processing = true;

                    let promise;

                    if (this.editing) {
                        promise = this.$http.put(
                            this.routeUri("api.training-classes.update", {
                                class: this.hash
                            }),
                            formData
                        );
                    } else {
                        promise = this.$http.post(
                            this.routeUri("api.training-classes.store"),
                            formData
                        );
                    }

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));

                }
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 2000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
    },
    watch: {
        item: function(value) {
            this.form.getFieldDecorator("name", { initialValue: value.name });
        }
    }
}
</script>